import React from "react"
import { connect } from "react-redux"
import { Modal } from "react-bootstrap"
import { Link } from 'react-router-dom'
import InfiniteScroll from "react-infinite-scroller"

import moment from 'moment'

import { getMyOrders, getOrderHistory } from "../../model/car"

import { formatPrice, getOrderStatus, convertTimeToRecent } from "../common/common"
import { commonErr } from "../common/errors"
import { LoadingInline } from "../common/loading"

import Header from "../common/header"
import Footer from "../common/footer"
import SideBar from "../common/sidebar"
import TripFilter from "./tripfilter"

import trip from "../../static/img/trips.svg"

const viewMode = {
	UPCOMING: 0,
	HISTORY: 1
}

const defaultFilter = {
	sort: 3,
	userType: 0,
	status: 0,
	carId: "",
	fromTime: 0,
	toTime: 0,
}

class TripItem extends React.Component {
	getTimeFromFilter = (order, filter) => {
		
			if (order.trip !== null && !filter) {
					return convertTimeToRecent(order.trip.timeLastAction);
			}

			if (order.trip !== null && filter.sort == 2) {
					return convertTimeToRecent(order.tripDateFrom);
			}

			if (order.trip !== null && filter.sort == 3) {
					return convertTimeToRecent(order.trip.timeLastAction);
			}

			return convertTimeToRecent(order.timeCreated);
	}

	render() {
		
		const order = this.props.order;
		const info = order.carGroup;
	
		const status = getOrderStatus(order.status);
		const filter = this.props.filter;


		return <Link className="link-trip" to={{ pathname: `/trip/detail/${order.id}` }}>
						<div className="list-trips__item" key={order.id} > 
						
						<h5 className="font-bold">{info.groupName}</h5>
						<div className="trip-body d-flex flex-wrap mb-3"> 
							<div className="left"> 
								<div className="fix-img"><img src={info.avatarUrl} /></div>
							</div>
							<div className="right"> 
								<p> Bắt đầu: {moment(order.tripDateFrom).format("HH:mm dddd, DD/MM/YYYY")}</p>
								<p> Kết thúc: {moment(order.tripDateTo).format("HH:mm dddd, DD/MM/YYYY")}</p>
								<p className="total-price">Tổng tiền {formatPrice(order.price)}</p>
							</div>
						</div>
						<div className="trip-footer status-trips">
							<p><span className={status.class} />{status.name}</p>
							{order.trip && <span className="time">{this.getTimeFromFilter(order, filter)}</span>}
						</div>
				</div>
			</Link>
	}
}

class MyTrips extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			err: commonErr.INNIT,
			mode: 0,
			orders: [],
			filter: [],
		}
		this.viewMyOrders = this.viewMyOrders.bind(this);
		this.viewOrderHistory = this.viewOrderHistory.bind(this);
		this.getOrders = this.getOrders.bind(this);
		this.getMyOrders = this.getMyOrders.bind(this);
		this.getOrderHistory = this.getOrderHistory.bind(this);
		this.setFilter = this.setFilter.bind(this);
		this.resetFilter = this.resetFilter.bind(this);
		this.checkHasFilter = this.checkHasFilter.bind(this);
		this.toggleFilterTrip = this.toggleFilterTrip.bind(this);
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.getOrders(0)
	}

	viewMyOrders() {
		this.setState({
				mode: viewMode.UPCOMING
		}, () => {
				this.resetFilter();
		})
	}

	viewOrderHistory() {
		this.setState({
				mode: viewMode.HISTORY
		}, () => {
			this.resetFilter();
		})
	}

	getOrders(filter) {

		const { mode } = this.state; 

		if (mode === viewMode.UPCOMING) {
				this.getMyOrders(filter);
		} else {
			this.getOrderHistory(filter);
		}
	}

	getMyOrders(filter) {

		this.setState({
				err: commonErr.LOADING
		});

		getMyOrders(filter, 0, 10).then(resp => {
				if (resp.data.error >= commonErr.SUCCESS && resp.data.data.orders) {
						this.setState({
								orders: resp.data.data.orders,
								more: resp.data.data.more,
								err: resp.data.error
						});
					
				} else {
						this.setState({
								err: resp.data.error,
								orders: null,
								more: 0
						});
				}
		});
	}

	getOrderHistory(filter) {
	
		this.setState({
				err: commonErr.LOADING
		});

		getOrderHistory(filter, 0, 10).then((resp) => {
				if (resp.data.error >= commonErr.SUCCESS && resp.data.data.orders) {
						this.setState({
								orders: resp.data.data.orders,
								more: resp.data.data.more,
								err: resp.data.error
						});
				} else {
						this.setState({
								err: resp.data.error,
								orders: null,
								more: 0
						});
				}
		});
	}

  getOrdersMore() {
		
		const { filter, mode, orders } = this.state;
		const nextPos = orders.length;
		
		if (mode == viewMode.UPCOMING) {
				getMyOrders(filter, nextPos, 10).then((resp) => {
						if (resp.data.error >= commonErr.SUCCESS && resp.data.data.orders) {
								this.setState({
										orders: orders.concat(resp.data.data.orders),
										// profiles: this.state.profiles.concat(resp.data.data.profiles),
										// cars: this.state.cars.concat(resp.data.data.cars),
										more: resp.data.data.more,
										err: resp.data.error
								});
						} else {
								this.setState({
										err: resp.data.error,
										more: 0
								});
						}
				});
		} else {
				getOrderHistory(filter, nextPos, 10).then((resp) => {
					if (resp.data.error >= commonErr.SUCCESS && resp.data.data.orders) {
								
								this.setState({
										orders: orders.concat(resp.data.data.orders),
										// profiles: this.state.profiles.concat(resp.data.data.profiles),
										// cars: this.state.cars.concat(resp.data.data.cars),
										more: resp.data.data.more,
										// lastId: resp.data.data.lastId,
										err: resp.data.error
								});
						} else {
								this.setState({
										err: resp.data.error,
										more: 0
								});
						}
				});
		}
}

	setFilter(filter) {
		this.setState({
				filter: filter
		})
	}

	resetFilter() {
			this.setState({
					filter: []
			}, () => {
					this.getOrders(this.state.filter)
			})
	}

	toggleFilterTrip() {
		this.setState({
				isOpenFilterTrip: !this.state.isOpenFilterTrip
		})
}

	checkHasFilter() {
		const status = this.state.filter && this.state.filter.status > 0 ? this.state.filter.status : defaultFilter.status;
		const sortValue = this.state.filter && this.state.filter.sort > 0 ? this.state.filter.sort : defaultFilter.sort;
		// const userTypeValue = this.state.filter && this.state.filter.userType > 0 ? this.state.filter.userType : defaultFilter.userType;
		// const carId = this.state.filter && this.state.filter.carId ? this.state.filter.carId : "";
		// const fromTime = this.state.filter && this.state.filter.fromTime > 0 ? this.state.filter.fromTime : defaultFilter.fromTime;
		// const toTime = this.state.filter && this.state.filter.toTime > 0 ? this.state.filter.toTime : defaultFilter.toTime;
		// const stype = this.state.filter && this.state.filter.stype > 0 ? this.state.filter.stype : defaultFilter.stype;

	return status != defaultFilter.status
				|| sortValue != defaultFilter.sort
				// || userTypeValue != defaultFilter.userType
				// || carId != defaultFilter.carId
				// || fromTime != defaultFilter.fromTime
				// || toTime != defaultFilter.toTime
				// || stype != defaultFilter.stype
	}

	render() {
		var content;

		const { err, mode, orders, more, filter, isOpenFilterTrip } = this.state;

	
		
		// const hasFilter = this.checkHasFilter();
		if (err === commonErr.LOADING) {
				// content = <LoadingPage />
		} else if (err >= commonErr.SUCCESS && orders.length > 0) {

			content = <InfiniteScroll pageStart={0}
				loadMore={this.getOrdersMore.bind(this)}
				hasMore={more === 1}
				loader={<LoadingInline key={0} />}>
			{orders.map(orderInfo => <TripItem key={orderInfo.id} order={orderInfo} />)}
			</InfiniteScroll>
			
			// content = <div>{orders.map(orderInfo => <TripItem key={orderInfo.id} order={orderInfo} />)}</div>
			
	} else {
			content = <div className="has-not-trip">
				<img src={trip} className="img-fluid" />
				<p>Bạn chưa có chuyến nào trên hệ thống</p>
			</div>
		
		}
		return <div className="mioto-layout page-wrapper">
						<Header />
						<SideBar />
						<div className="content-wrapper">
							<div className="page-content fade-in-up">
								<div className="ibox list-trips__sect">
									<div className="ibox-head">
										<ul className="nav nav-tabs tabs-line">
											<li className="nav-item"><a className={`nav-link ${mode === viewMode.UPCOMING ? "active" : "deactive"}`} onClick={this.viewMyOrders} >Chuyến hiện tại </a></li>
											<li className="nav-item"><a className={`nav-link ${mode === viewMode.HISTORY ? "active" : "deactive"}`} onClick={this.viewOrderHistory} >Lịch sử chuyến</a></li>
										</ul>
										<a className={this.state.hasFilter ? "btn btn--m has-dot-red" : "btn btn--m"} onClick={this.toggleFilterTrip} href="#!"><i className="ic ic-filter-black"></i><span>Bộ lọc</span></a>
									</div>
									<div className="ibox-body">
									<div className="list-trips__wrapper">
													{content}
										</div> 
										</div>
									</div>
								</div>
							<Footer />
						</div>
							<Modal
                show={isOpenFilterTrip}
                onHide={this.toggleFilterTrip}
                dialogClassName="modal-md">
                <Modal.Header closeButton={true} closeLabel={""}>
                    <Modal.Title>Bộ lọc</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TripFilter
                        viewMode={viewMode}
                        filter={filter}
                        mode={mode}
                        resetFilter={this.resetFilter.bind(this)}
                        setFilter={this.setFilter.bind(this)}
                        getOrders={this.getOrders.bind(this)}
                        defaultFilter={defaultFilter}
                        checkHasFilter={this.checkHasFilter.bind(this)} />
                </Modal.Body>
           		</Modal>
						</div>
	}
}

export default MyTrips


// WEBPACK FOOTER //
// ./src/components/trip/mytrips.js